<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGlobalStore } from '@stores/global'
import Related from '@sections/blog/related.vue'
import Delimiter from '@sections/delimiter.vue'
import Markdown from 'vue3-markdown-it'
import Button from '@components/global/button.vue'

const global = useGlobalStore()
const router = useRouter()
const route = useRoute()
const loading = ref(false)
const article = ref({})
const requestArticle = ref(null)
const slug = computed(() => route.params.slug)

function cancelArticle() {
	if (requestArticle.value) requestArticle.value.cancel()
}
function getArticle() {
	loading.value = true
	article.value = {}
	cancelArticle()
	let axiosSource = axios.CancelToken.source()
	requestArticle.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/news/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			article.value = a.data
		})
		.catch((e) => {})
}
getArticle()

watch(slug, async () => {
	getArticle()
})
</script>
<template>
	<template v-if="article.title">
		<div class="sticky top-28 ml-10 hidden md:flex">
			<Button @click="router.back()" class="primary relative aspect-square w-10">
				<i class="fa-regular fa-arrow-left absolute-center"></i>
			</Button>
		</div>
		<section class="container max-w-5xl">
			<img :src="article.image" alt="blog image" class="aspect-video h-full w-full rounded-xl object-cover" />
			<div class="mt-4 flex flex-col gap-4 md:p-10">
				<div class="flex flex-row gap-4">
					<span class="font-medium text-primaryLight">
						{{ article.category.name }}
					</span>
					<span class="flex items-center gap-3 font-medium text-sm text-primaryLight">
						<i class="fa-solid fa-calendar" />
						{{
							new Date(article.published_at).toLocaleDateString('en-US', {
								month: 'short',
								day: '2-digit',
								year: 'numeric',
							})
						}}
					</span>
				</div>
				<h5 class="title animation w-fit border-b border-bgMain pb-1 font-semibold">
					{{ article.title }}
				</h5>
			</div>

			<div class="mb-10 border border-dashed border-border"></div>

			<Markdown class="markdown article" :source="article.body" :breaks="true" />
		</section>
	</template>

	<!-- <Related /> -->
	<Delimiter :isDark="true" />
</template>
